import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './HouseRules.css';

interface LocationState {
  bookingData: {
    checkIn: Date;
    checkOut: Date;
    nights: number;
    subtotal: number;
    discountAmount: number;
    taxAmount: number;
    total: number;
  };
}

const HouseRules: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const [agreedToRules, setAgreedToRules] = React.useState(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleContinue = () => {
    if (state?.bookingData && agreedToRules) {
      navigate('/checkout', { state: { bookingData: state.bookingData } });
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="house-rules-container">
      <div className="house-rules-content">
        <h1>House Rules</h1>

        {state?.bookingData && (
          <div className="booking-notice">
            <p>Please review the following house rules in order to proceed to reserving.</p>
          </div>
        )}

        <div className="rules-section">
          <h2>Checking in and out</h2>
          <ul>
            <li><strong>Check-in:</strong> After 3:00 PM</li>
            <li><strong>Checkout:</strong> Before 11:00 AM</li>
            <li><strong>Self check-in</strong> with smart lock</li>
          </ul>
        </div>

        <div className="rules-section">
          <h2>During your stay</h2>
          <ul>
            <li>5 guests maximum</li>
            <li><strong>Quiet hours:</strong> 10:00 PM - 7:00 AM</li>
            <li>No parties or events</li>
            <li>No commercial photography</li>
            <li>No smoking</li>
          </ul>
        </div>

        <div className="rules-section">
          <h2>Before you leave</h2>
          <ul>
            <li>Gather used towels</li>
            <li>Turn things off</li>
            <li>Return keys</li>
            <li>Lock up</li>
          </ul>
        </div>

        <div className="rules-section">
          <h2>Additional requests</h2>
          <ul>
            <li>Cleaning is not required</li>
            <li>Please check for any forgotten belongings</li>
          </ul>
        </div>

        <div className="rules-section">
          <h2>Good Neighbor Guide</h2>
          <p className="guide-intro">
            As required by Riverside city municipal law, please review the good neighbor brochure below:
          </p>
          <div className="guide-image-container">
            <img
              src="https://directbooking-images-071128453175.s3.us-west-2.amazonaws.com/good_neighbor_guide.png"
              alt="Good Neighbor Guide"
              className="guide-image"
            />
          </div>
        </div>

        {state?.bookingData ? (
          <>
            <div className="agreement-section">
              <label className="agreement-checkbox">
                <input
                  type="checkbox"
                  checked={agreedToRules}
                  onChange={(e) => setAgreedToRules(e.target.checked)}
                />
                <span>I have read and agree to the house rules and good neighbor guide</span>
              </label>
            </div>

            <div className="rules-actions">
              <button className="back-button-secondary" onClick={handleBack}>
                ← Back to Property
              </button>
              <button
                className="continue-button"
                onClick={handleContinue}
                disabled={!agreedToRules}
              >
                Continue to Payment
              </button>
            </div>
          </>
        ) : (
          <div className="rules-actions">
            <button className="back-button-secondary" onClick={handleBack}>
              ← Back
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HouseRules;
